import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, ReceiptText } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { listInvoices, invoicePdf } from "../../api/billing";
import { saveBlob } from "../../native/saveFile";

// فواتير الاشتراك: تُرسل تلقائياً بالبريد بعد كل تجديد، ويمكن تنزيلها من هنا في أي وقت.
export const InvoiceList = () => {
  const { t, i18n } = useTranslation();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    listInvoices()
      .then((res) => setRows(res.invoices || []))
      .catch(() => setRows([]));
  }, []);

  const download = async (row) => {
    const blob = await invoicePdf(row.number, i18n.language);
    await saveBlob(blob, `helcoo-invoice-${row.serial || ""}-${row.number}.pdf`);
  };

  return (
    <NeuCard data-testid="invoice-list">
      <p className="label-xs flex items-center gap-2">
        <ReceiptText className="h-4 w-4 text-primary" /> {t("billing.invoices")}
      </p>
      {rows.length ? (
        <ul className="mt-4 grid gap-2">
          {rows.map((row) => (
            <li
              key={row.number}
              className="neu-in flex flex-wrap items-center justify-between gap-3 rounded-2xl px-4 py-3"
              data-testid={`invoice-row-${row.number}`}
            >
              <div className="min-w-0">
                <p className="font-mono text-xs font-bold">{row.number}</p>
                <p className="mt-1 text-xs text-muted-foreground num">
                  {(row.at || "").slice(0, 10)} · {row.period} · {Number(row.total).toFixed(2)}{" "}
                  {String(row.currency || "").toUpperCase()}
                </p>
              </div>
              <NeuButton
                className="flex items-center gap-2 py-2 text-xs sm:px-4"
                data-testid={`invoice-download-${row.number}`}
                onClick={() => download(row)}
              >
                <Download className="h-3.5 w-3.5" /> PDF
              </NeuButton>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-3 text-xs text-muted-foreground" data-testid="invoice-empty">
          {t("billing.noInvoices")}
        </p>
      )}
    </NeuCard>
  );
};
